import * as Joi from "joi";
import { Moment } from 'moment';
import { Column } from 'typeorm';
import { booleanTransformer, momentTransformer } from 'typeormgen';
import ProdBase from '../prod-base.entity';

export default class ChangeLookPicture extends ProdBase {
	@Column('varchar')
	mobile_id: string;

	@Column('int')
	prod_id: number;

	@Column('int')
	change_id: number;

	@Column('int')
	picture_id: number;

	@Column({ type: 'tinyint', transformer: booleanTransformer })
	main_photo: boolean;

	@Column({ type: 'timestamp', transformer: momentTransformer })
	last_updated_time: Moment;

	@Column('int')
	last_updated_user: number;

	@Column('int')
	created_by: number;

	@Column({ type: 'timestamp', transformer: momentTransformer })
	date_created: Moment;

	title: string;

	static rules() {
		return {
			...super.rules(),
			change_id: Joi.number().integer(),
			created_by: Joi.number().integer(),
			date_created: Joi.date().allow(null),
			last_updated_time: Joi.date().allow(null),
			last_updated_user: Joi.number().integer(),
			main_photo: Joi.boolean(),
			mobile_id: Joi.string().max(36).allow(null, ''),
			picture_id: Joi.number().integer(),
			title: Joi.string(),
		};
	}

	toJSON() {
		return {
			...super.toJSON(),
			change_id: this.change_id,
			created_by: this.created_by,
			date_created: this.date_created,
			last_updated_time: this.last_updated_time,
			last_updated_user: this.last_updated_user,
			main_photo: this.main_photo,
			mobile_id: this.mobile_id,
			picture_id: this.picture_id,
			title: this.title,
		};
	}

	getUploadDate() {
		return this.date_created.local().format('MMMM DD, YYYY');
	}
}
